import { render, staticRenderFns } from "./OrderPD.vue?vue&type=template&id=19a593ba"
import script from "./OrderPD.vue?vue&type=script&lang=js"
export * from "./OrderPD.vue?vue&type=script&lang=js"
import style0 from "./OrderPD.vue?vue&type=style&index=0&id=19a593ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports